import { Alert, ShowIf } from '@ztechapps/webui.util'
import React from 'react'
import { useContext } from './context'

export const ErrorDisplay = () => {
  const context = useContext()
  const [errorMessage] = context.errorMessage
  return (
    <ShowIf condition={!!errorMessage}>
      <Alert>{errorMessage}</Alert>
    </ShowIf>
  )
}
